<template>
  <div>
    <loading v-if="loadingMovementDetails || loadingChangeReceivedQty" />
    <base-modal
      :showing="visible && !packetComplainModal.visible"
      size="max-w-5xl"
      @close="onClose"
      @opened="onOpened"
    >
      <base-card
        :with-style="false"
        title="Detail Koli"
        description="Data detail koli"
      >
        <div class="grid gap-6 border-t pt-5 sm:grid-cols-2">
          <div>
            <dt class="text-xs text-gray-700">Kode</dt>
            <dd class="mt-1 text-sm font-bold text-gray-900">
              {{ packet.attributes?.code }}
            </dd>
          </div>
          <div>
            <dt class="text-xs text-gray-700">Nama</dt>
            <dd class="mt-1 text-sm font-bold text-gray-900">
              {{ packet.attributes?.name }}
            </dd>
          </div>
          <div class="col-span-full">
            <dt class="text-xs text-gray-700">Barang</dt>
            <dd class="mt-1">
              <datatable :columns="movementDetailColumns">
                <template #tbody="{ classes }">
                  <template
                    v-for="(movementDetail, index) in movementDetails.data"
                  >
                    <tr :key="index" :class="classes.tr">
                      <td :class="classes.td">
                        <div class="flex items-center gap-2">
                          <Icon
                            v-if="checkMovementDetailHasQr(movementDetail)"
                            icon="heroicons:qr-code"
                            class="h-4 w-4"
                          />
                          <p
                            v-if="
                              movementDetail.attributes.product_type ===
                              'reguler'
                            "
                          >
                            {{ movementDetail.attributes.product_code }}
                          </p>
                          <p v-else>
                            {{ movementDetail.attributes.product_code }} (FREE)
                          </p>
                        </div>
                      </td>
                      <td :class="classes.td">
                        {{ movementDetail.attributes.product_name }}
                      </td>
                      <td :class="[classes.td, 'text-right']">
                        {{ movementDetail.attributes.shipped_product_qty }}
                      </td>
                      <td
                        v-if="withReceiveInput"
                        :class="[classes.td, 'text-right']"
                      >
                        <span>{{
                          movementDetail.attributes.received_product_qty
                        }}</span>
                      </td>
                      <td
                        v-if="false && withComplainForm"
                        :class="[classes.td, 'text-right']"
                      >
                        <button
                          class="ml-auto flex items-center justify-end"
                          @click="onToggleComplain(index)"
                        >
                          <Icon
                            :icon="
                              visibleComplainIds.includes(index)
                                ? 'heroicons:chevron-down'
                                : 'heroicons:chevron-right'
                            "
                            class="h-4 w-4"
                          />
                        </button>
                      </td>
                      <td
                        v-if="withStatus"
                        :class="[classes.td, 'text-center']"
                        :title="getMovementDetailStatus(movementDetail)"
                      >
                        <Icon
                          :icon="getMovementDetailStatusIcon(movementDetail)"
                          :class="[
                            'mx-auto h-5 w-5',
                            getMovementDetailStatusIconColor(movementDetail),
                          ]"
                        />
                      </td>
                      <td
                        v-if="withStatus || withBatches"
                        :class="[classes.td, 'text-right']"
                      >
                        <base-button
                          v-if="withStatus"
                          size="sm"
                          :color="
                            visibleProductBatches.includes(movementDetail.id)
                              ? 'warning'
                              : 'primary'
                          "
                          @click="onToggleProductBatch(movementDetail.id)"
                          >{{
                            !visibleProductBatches.includes(movementDetail.id)
                              ? 'Pilih Batch'
                              : 'Tutup Batch'
                          }}</base-button
                        >
                        <button v-else class="text-right" @click="onToggleProductBatch(movementDetail.id)">
                          <Icon :icon="visibleProductBatches.includes(movementDetail.id) ? 'heroicons:chevron-down' : 'heroicons:chevron-right'" />
                        </button>
                      </td>
                    </tr>
                    <template
                      v-if="visibleProductBatches.includes(movementDetail.id)"
                    >
                      <tr
                        v-for="(batch, batchIndex) in getIncludedByType(
                          movementDetails,
                          'batches',
                          movementDetail
                        )"
                        :key="`${packet.id}-${movementDetail.id}-${batch.attributes.no_batch}`"
                        class="bg-gray-50"
                      >
                        <td :class="[classes.td, 'text-center']">
                          <base-radio
                            v-if="
                              withReceiveScanInput &&
                              batch.attributes.pickup_method === 'qrcode'
                            "
                            label=""
                            :val="{
                              productIndex: index,
                              batchIndex: batchIndex,
                            }"
                            v-model="qrScan"
                          />
                        </td>
                        <td :class="classes.td">
                          {{ batch.attributes.no_batch }}
                        </td>
                        <td :class="[classes.td, 'text-right']">
                          {{ batch.attributes.product_qty }}
                        </td>
                        <td v-if="withStatus" :class="[classes.td, 'text-right']">
                          <input
                            v-if="
                              batch.attributes.pickup_method === 'manual' ||
                              !withReceiveScanInput
                            "
                            type="text"
                            class="border-0 bg-transparent p-0 text-right text-sm placeholder-gray-300 focus:ring-0"
                            placeholder="Masukkan jumlah"
                            :value="batch.attributes.received_product_qty"
                            @change="
                              (e) => onChangeReceivedQty(e, index, batchIndex)
                            "
                          />
                          <span v-else>{{
                            batch.attributes.received_product_qty
                          }}</span>
                        </td>
                        <td colspan="2"></td>
                      </tr>
                    </template>
                    <tr
                      v-if="
                        false &&
                        withComplainForm &&
                        visibleComplainIds.includes(index)
                      "
                      :key="`${index}-complain-form`"
                      :class="[classes.tr, 'bg-gray-50']"
                    >
                      <td></td>
                      <td :class="classes.td">Jumlah Komplain</td>
                      <td :class="classes.td">
                        <div class="flex justify-end">
                          <input
                            type="text"
                            class="m-0 w-auto border-0 bg-transparent p-0 text-right text-sm focus:ring-0"
                            placeholder="0"
                            :readonly="packet.complained"
                            v-model="complains[index].qty"
                          />
                        </div>
                      </td>
                      <td></td>
                    </tr>
                  </template>
                </template>
              </datatable>
            </dd>
          </div>

          <div
            v-if="false && (withComplainForm || packet.complained)"
            class="col-span-full flex justify-end"
          >
            <base-button
              :disabled="!packet.complained && !hasCompain"
              @click="onSubmitComplain"
            >
              <Icon
                icon="heroicons:chat-bubble-left-ellipsis-solid"
                class="h-4 w-4"
              />
              {{ packet.complained ? 'Lihat Komplain' : 'Ajukan Komplain' }}
            </base-button>
          </div>
        </div>
      </base-card>
    </base-modal>

    <view-packet-complain-modal
      :packet="packet"
      :products="complains"
      :visible="packetComplainModal.visible"
      @close="packetComplainModal.visible = false"
      @complained="onComplained"
    />

    <base-modal
      :showing="selectBatchModal.visible"
      @close="selectBatchModal.visible = false"
    >
      <base-card :with-style="false" title="Pilih Batch">
        <datatable
          :columns="[
            { id: 'code', name: 'No Batch' },
            { id: 'qty', name: 'Jumlah Dikirim' },
            { id: 'received_qty', name: 'Jumlah Diterima' },
          ]"
        >
          <template #tbody="{ classes }">
            <tr
              v-for="batch in selectBatchModal.batches"
              :key="batch.id"
              class="cursor-pointer hover:bg-green-100"
              @click="onSelectBatchModal(batch.id)"
            >
              <td :class="classes.td">{{ batch.code }}</td>
              <td :class="classes.td">{{ batch.qty }}</td>
              <td :class="classes.td">{{ batch.received_qty }}</td>
            </tr>
          </template>
        </datatable>
      </base-card>
    </base-modal>
  </div>
</template>

<script>
import BaseModal from '@/components/base/BaseModal.vue';
import BaseRadio from '@/components/base/BaseRadio.vue';
import ViewPacketComplainModal from './view-packet-complain-modal.vue';
import { requestMixin } from '@/mixins/request/request';
import { mapActions } from 'vuex';

export default {
  mixins: [requestMixin],
  components: {
    BaseModal,
    BaseRadio,
    ViewPacketComplainModal,
  },
  props: {
    visible: Boolean,
    packet: Object,
    stockMovement: Object,
    withComplainForm: {
      type: Boolean,
      default: true,
    },
    withReceiveInput: Boolean,
    withReceiveScanInput: {
      type: Boolean,
      default: true,
    },
    withStatus: Boolean,
    withBatches: Boolean
  },
  emits: ['close', 'complained', 'update-received-qty'],
  data() {
    return {
      qrScan: {
        productIndex: null,
        batchIndex: null,
      },
      reload: true,
      visibleComplainIds: [],
      packetComplainModal: {
        visible: false,
        packetId: null,
      },
      complains: [],
      movementDetails: {
        data: [],
      },
      visibleProductBatches: [],
      loadingChangeReceivedQty: false,
      loadingMovementDetails: false,
      selectBatchModal: {
        visible: false,
        batches: [],
        productIndex: null,
      },
    };
  },
  computed: {
    hasCompain() {
      return this.complains.filter(
        (complain) => complain.qty && parseInt(complain.qty) > 0
      ).length;
    },
    movementDetailColumns() {
      return [
        { id: 'code', name: 'Kode' },
        { id: 'name', name: 'Nama' },
        { id: 'shipped_qty', name: 'Jumlah Dikirim', theadClass: 'text-right' },
        ...(this.withReceiveInput
          ? [
              {
                id: 'received_qty',
                name: 'Jumlah Diterima',
                theadClass: 'text-right',
              },
            ]
          : []),
        ...(this.withStatus
          ? [
              {
                id: 'status',
                name: 'Status',
                theadClass: 'text-center',
              },
            ]
          : []),
        ...(this.withStatus || this.withBatches
          ? [
              {
                id: 'aksi',
                name: 'Aksi',
                theadClass: 'text-right',
              },
            ]
          : []),
        // ...(false && this.withComplainForm ? [{ id: 'action', name: '', theadClass: 'text-right' }] : []),
      ];
    },
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    checkMovementDetailHasQr(movementDetail) {
      // cek batch apakah ada yg tipenya unique qr
      return movementDetail && false;
    },
    getMovementDetailStatus(movementDetail) {
      if (!movementDetail.attributes.received_product_qty_modified) {
        return 'Barang belum dicek';
      }

      if (
        movementDetail.attributes.received_product_qty !==
        movementDetail.attributes.shipped_product_qty
      ) {
        return 'Barang komplain';
      }

      return '';
    },
    getMovementDetailStatusIcon(movementDetail) {
      if (!movementDetail.attributes.received_product_qty_modified) {
        return 'heroicons:exclamation-triangle-solid';
      }

      if (
        movementDetail.attributes.received_product_qty !==
        movementDetail.attributes.shipped_product_qty
      ) {
        return 'heroicons:x-circle-solid';
      }

      return 'heroicons:check-badge-solid';
    },
    getMovementDetailStatusIconColor(movementDetail) {
      if (!movementDetail.attributes.received_product_qty_modified) {
        return 'text-yellow-500';
      }

      if (
        movementDetail.attributes.received_product_qty !==
        movementDetail.attributes.shipped_product_qty
      ) {
        return 'text-red-500';
      }

      return 'text-green-500';
    },
    async loadMovementDetails() {
      this.loadingMovementDetails = true;

      const [res, err] = await this.request(
        `/api/v1/packets/${this.packet.id}/movement-details`,
        {
          params: {
            include: 'batches',
            'fields[movement-details]':
              'product_type,product_code,product_qr_code,product_name,shipped_product_qty,received_product_qty,received_product_qty_modified,batches',
            'fields[product-batches]':
              'no_batch,pickup_method,product_qty,received_product_qty',
          },
        }
      );

      if (!err) {
        this.movementDetails = res;
      }

      this.loadingMovementDetails = false;
    },
    onClose() {
      this.reload = true;
      this.$emit('close');

      if (this.withReceiveInput && this.withReceiveScanInput) {
        document.removeEventListener('barcode-scan', this.onQrScanned);
      }
    },
    onOpened() {
      if (this.reload) {
        this.loadMovementDetails();

        this.visibleComplainIds = [];
        this.visibleProductBatches = [];
        this.qrScan.productIndex = null;
        this.qrScan.batchIndex = null;

        // this.complains = this.packet.products.map((product) => ({
        //   productId: product.product_id,
        //   productCode: product.product_code,
        //   qty: product.complained_product_qty,
        // }));

        if (this.withReceiveInput && this.withReceiveScanInput) {
          document.addEventListener('barcode-scan', this.onQrScanned);
        }
      }
    },
    async onQrScanned(e) {
      const qrcode = e.detail.text;
      const productIndex = this.movementDetails.data.findIndex(
        (product) => product.attributes.received_product_qty < product.attributes.shipped_product_qty && product.attributes.product_qr_code === qrcode
      );

      if (productIndex === -1) {
        await this.submitScanQty(qrcode);
      } else {
        if (
          this.qrScan.productIndex !== productIndex ||
          this.qrScan.batchIndex === null
        ) {
          const product = this.movementDetails.data[productIndex];
          const batches = this.getIncludedByType(this.movementDetails, 'batches', product)
          const batchQrList = batches.filter(
            (batch) => batch.attributes.pickup_method === 'qrcode'
          );

          if (!batchQrList.length) {
            this.createAlert({
              status: 'error',
              data: 'Tidak ada batch scan qr',
              timeout: 500,
            });
          } else {
            const batchQrListHasRemainder = batchQrList.filter(
              (batch) => batch.attributes.received_product_qty < batch.attributes.product_qty
            );

            if (!batchQrListHasRemainder.length) {
              this.createAlert({
                status: 'error',
                data: 'Tidak ada batch scan qr yang tersisa',
                timeout: 500,
              });
            } else {
              if (batchQrListHasRemainder.length === 1) {
                this.selectBatchModal.productIndex = productIndex;

                this.onSelectBatchModal(batchQrListHasRemainder[0].id);
              } else {
                this.selectBatchModal.batches = batchQrListHasRemainder.map(
                  (batch) => ({
                    id: batch.id,
                    code: batch.attributes.no_batch,
                    qty: batch.attributes.product_qty,
                    received_qty: batch.attributes.received_product_qty || 0,
                  })
                );
                this.selectBatchModal.productIndex = productIndex;
                this.selectBatchModal.visible = true;
              }
            }
          }
        } else {
          const batch =
            this.movementDetails.included[
              this.qrScan.batchIndex
            ];

          if (batch.attributes.received_product_qty >= batch.attributes.product_qty) {
            this.createAlert({
              status: 'error',
              data: 'Tidak ada batch scan qr yang tersisa',
              timeout: 500,
            });
          } else {
            const success = await this.submitReceivedQty(
              this.qrScan.productIndex,
              batch.id,
              batch.attributes.received_product_qty + 1
            );

            if (success) {
              this.movementDetails.included[this.qrScan.batchIndex].attributes.received_product_qty++;
              this.movementDetails.data[this.qrScan.productIndex]
                .attributes.received_product_qty++;
              this.movementDetails.data[this.qrScan.productIndex]
                .attributes.received_product_qty_modified = true;
              
              this.$emit('update-received-qty', 1);
            }
          }
        }
      }
    },
    async onSelectBatchModal(batchId) {
      const productId =
        this.movementDetails.data[this.selectBatchModal.productIndex].attributes.product_code;

      if (!this.visibleProductBatches.includes(productId)) {
        this.visibleProductBatches.push(productId);
      }

      const batchIndex = this.movementDetails.included.findIndex(included => included.type === 'product-batches' && included.id === batchId)
      const batch =
        this.movementDetails.included[
          batchIndex
        ];

      this.qrScan.productIndex = this.selectBatchModal.productIndex;
      this.qrScan.batchIndex = batchIndex;

      this.selectBatchModal.visible = false;

      const success = await this.submitReceivedQty(
        this.selectBatchModal.productIndex,
        batchId,
        batch.attributes.received_product_qty + 1
      );

      if (success) {
        this.movementDetails.included[
          batchIndex
        ].attributes.received_product_qty++;
        this.movementDetails.data[this.selectBatchModal.productIndex]
          .attributes.received_product_qty++;
        this.movementDetails.data[
          this.selectBatchModal.productIndex
        ].attributes.received_product_qty_modified = true;

        this.$emit('update-received-qty', 1);
      }
    },
    onSubmitComplain() {
      this.reload = false;
      this.packetComplainModal.visible = true;
    },
    onToggleComplain(index) {
      if (this.visibleComplainIds.includes(index)) {
        this.visibleComplainIds.splice(
          this.visibleComplainIds.findIndex((i) => i === index),
          1
        );
      } else {
        this.visibleComplainIds.push(index);
      }
    },
    onComplained() {
      this.packetComplainModal.visible = false;
      this.$emit('complained');
    },
    async onChangeReceivedQty(e, index, batchIndex) {
      const { value } = e.target;
      const movementDetail = this.movementDetails.data[index];
      const batches = this.getIncludedByType(
        this.movementDetails,
        'batches',
        movementDetail
      );
      const batch = batches[batchIndex];

      if (isNaN(value)) {
        e.target.value = batch.attributes.received_product_qty;
      } else {
        const qty = Number(value);

        if (qty < 0 || qty > batch.attributes.product_qty) {
          e.target.value = batch.attributes.received_product_qty;
        } else {
          const success = await this.submitReceivedQty(
            index,
            batch.id,
            e.target.value
          );

          if (success) {
            this.updateMovementDetailBatch(
              batch,
              'received_product_qty',
              Number(e.target.value)
            );

            const oldQty = Number(
              this.movementDetails.data[index].attributes.received_product_qty
            );
            const newQty = Number(
              success.data.data.attributes.received_product_qty
            );

            this.movementDetails.data[index].attributes.received_product_qty =
              newQty;
            this.movementDetails.data[
              index
            ].attributes.received_product_qty_modified = true;

            this.$emit('update-received-qty', newQty - oldQty);
          } else {
            e.target.value = batch.attributes.received_product_qty;
          }
        }
      }
    },
    onToggleProductBatch(movementDetailId) {
      if (this.visibleProductBatches.includes(movementDetailId)) {
        this.visibleProductBatches = this.visibleProductBatches.filter(
          (i) => i !== movementDetailId
        );
      } else {
        this.visibleProductBatches.push(movementDetailId);
      }
    },
    async submitScanQty(qrcode) {
      this.loadingChangeReceivedQty = true;

      const [res, err] = await this.request(
        `/api/v1/packets/${this.packet.id}/-actions/scan-qrcode`,
        {
          method: 'post',
          data: {
            qrcode,
          },
        }
      );

      if (err) {
        this.createAlert({
          status: 'error',
          data: 'QR code tidak ditemukan',
          timeout: 500,
        });
      } else {
        this.qrScan.productIndex = null;
        this.qrScan.batchIndex = null;

        const productIndex = this.movementDetails.data.findIndex(
          (product) => product.id === res.movement_detail_uuid
        );
        const batchIndex = this.movementDetails.included.findIndex(
          (batch) => batch.id === res.batch_uuid
        );

        this.movementDetails.included[
          batchIndex
        ].attributes.received_product_qty += res.qty;
        this.movementDetails.data[productIndex].attributes.received_product_qty += res.qty;
        this.movementDetails.data[productIndex].attributes.received_product_qty_modified = true;

        this.$emit('update-received-qty', 1);
      }

      this.loadingChangeReceivedQty = false;
    },
    async submitReceivedQty(index, batchId, value) {
      this.loadingChangeReceivedQty = true;

      const movementDetail = this.movementDetails.data[index];

      const [res, err] = await this.request(
        `/api/v1/movement-details/${movementDetail.id}/-actions/receive-batch-qty`,
        {
          method: 'patch',
          data: {
            batch_id: batchId,
            qty: value,
          },
        }
      );

      if (err) {
        this.loadingChangeReceivedQty = false;

        this.createAlert({
          status: 'error',
          data: this.getRequestErrorMessage(err),
        });

        return false;
      } else {
        this.loadingChangeReceivedQty = false;

        return { data: res };
      }
    },
    updateMovementDetailBatch(batch, key, value) {
      const batchIndex = this.movementDetails.included.findIndex(
        (included) =>
          included.type === 'product-batches' && included.id === batch.id
      );

      this.movementDetails.included[batchIndex].attributes[key] = value;
    },
  },
};
</script>
